import { containsNbsp, nbspToSpace } from './helpers'

const replaceNbspInDataEvent = (evt: CKEDITOR.eventInfo) => {
  const dataValue = evt?.data?.dataValue

  if (typeof dataValue !== 'string' || !containsNbsp(dataValue)) {
    return
  }

  const dataValueDOM = new DOMParser().parseFromString(
    nbspToSpace(dataValue),
    'text/html'
  )

  const bookmarkEls = dataValueDOM.querySelectorAll('[data-cke-bookmark]')

  bookmarkEls.forEach((bookmarkEl) => {
    bookmarkEl.innerHTML = '&nbsp;'
  })

  evt.data.dataValue = dataValueDOM.body.innerHTML
}

export const nbspToSpacePlugin: CKEDITOR.pluginDefinition = {
  init: (editor) => {
    editor.on('getData', replaceNbspInDataEvent, null, null, 0)
  },
}
